import AiRobotDemo from './src/main';

/* istanbul ignore next */
AiRobotDemo.install = function(Vue) {
  Vue.component(AiRobotDemo.name, AiRobotDemo);
};

export default AiRobotDemo;
